var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass: "sip-mobile-bottom-nav d-md-none",
      attrs: { "aria-label": "School Admin Mobile Navigation" },
    },
    [
      _c(
        "div",
        { staticClass: "sip-mobile-bottom-nav__inner" },
        [
          _c(
            "router-link",
            {
              staticClass: "sip-mobile-nav-item",
              class: { "is-active": _vm.isDashboardActive },
              attrs: { to: "/home", "aria-label": "Dashboard" },
            },
            [
              _c(
                "div",
                { staticClass: "sip-mobile-nav-item__icon-wrap" },
                [_c("admin-icon", { attrs: { name: "home", size: 20 } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "sip-mobile-nav-item__label" }, [
                _vm._v(_vm._s(_vm.trans("general.dashboard") || "Dashboard")),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "sip-mobile-nav-item",
              class: { "is-active": _vm.isStudentsActive },
              attrs: { to: "/student/admission", "aria-label": "Students" },
            },
            [
              _c(
                "div",
                { staticClass: "sip-mobile-nav-item__icon-wrap" },
                [_c("admin-icon", { attrs: { name: "users", size: 20 } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "sip-mobile-nav-item__label" }, [
                _vm._v(_vm._s(_vm.trans("student.student") || "Students")),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "sip-mobile-nav-item",
              class: { "is-active": _vm.isEmployeesActive },
              attrs: { to: "/employee", "aria-label": "Employees" },
            },
            [
              _c(
                "div",
                { staticClass: "sip-mobile-nav-item__icon-wrap" },
                [_c("admin-icon", { attrs: { name: "user", size: 20 } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "sip-mobile-nav-item__label" }, [
                _vm._v(_vm._s(_vm.trans("employee.employee") || "Staff")),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "sip-mobile-nav-item",
              class: { "is-active": _vm.isAcademicActive },
              attrs: { to: "/academic", "aria-label": "Academic" },
            },
            [
              _c(
                "div",
                { staticClass: "sip-mobile-nav-item__icon-wrap" },
                [_c("admin-icon", { attrs: { name: "book", size: 20 } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "sip-mobile-nav-item__label" }, [
                _vm._v(_vm._s(_vm.trans("academic.academic") || "Academic")),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sip-mobile-nav-item sip-mobile-nav-item--btn",
              class: { "is-active": _vm.isSidebarActive },
              attrs: { type: "button", "aria-label": "Toggle navigation menu" },
              on: { click: _vm.toggleSidebar },
            },
            [
              _c(
                "div",
                { staticClass: "sip-mobile-nav-item__icon-wrap" },
                [_c("admin-icon", { attrs: { name: "menu", size: 20 } })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "sip-mobile-nav-item__label" }, [
                _vm._v(_vm._s(_vm.trans("general.menu") || "Menu")),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }